import { render } from "./ProjectCanvas.vue?vue&type=template&id=6a971917"
import script from "./ProjectCanvas.vue?vue&type=script&lang=js"
export * from "./ProjectCanvas.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__